<span>
    {{ (fuelState?.LV?.V | number: '1.1-1') }} {{ fuelState?.LV?.V ? 'L' : '' }}
</span>
